<script>
export default {
  name: 'Toolbar',
  data() {
    return {
      loading: null,
    };
  },
  methods: {
    async logout() {
      const loading = this.$loading({ fullscreen: true, text: '正在退出...' });
      if (this.isAdmin) {
        await this.$apis.auth.logout();
      } else {
        await this.$apis.orgAuth.logout();
      }
      this.$store.commit('SET_ADMIN', '');
      loading.close();
      this.$router.push('/admin/login');
    },
    toggleSideMenu() {
      this.$store.commit('TOGGLE_SIDE_MENU', !this.$store.state.isCollapse);
    },
  },
};
</script>

<template lang="pug">
.nav-bar
  .brand
    .menu-btn(@click="toggleSideMenu")
      i.fa.fa-navicon
    strong.logo 后台管理系统
  ul.menus
    li.menu-item
      .menu__item(@click="logout")
        i.fa.fa-sign-out
</template>

<style lang="stylus" scoped>
barHeight = 60px
bgColor = #2F2F2F
bgDarkColor = #1f1f1f

.nav-bar
  height barHeight
  background bgColor
  box-sizing border-box
  background-position center
  background-size 100% 100%
  position relative
  .brand
    height 100%
    line-height barHeight
    display flex
    align-items center
    float left
    .menu-btn
      color #fff
      line-height 1
      padding 6px
      border-radius 50%
      text-align center
      cursor pointer
      margin 12px 14px
      &:active
        background bgDarkColor
      .fa
        font-size 20px
        height 24px
        width 24px
        line-height 24px
    .logo
      display inline-block
      color #ffffff
      font-size 20px
      height 32px
      line-height 32px
      margin-right 15px
  .menus
    box-sizing border-box
    list-style none
    text-align right
    margin 0
    padding 0
    float right
    li.menu-item
      display inline-block
      position relative
      padding 15px
      vertical-align middle
      .lang-text
        color #fff
      .menu__item
        position relative
        display inline-block
        height 30px
        width 30px
        line-height 30px
        font-size 16px
        font-weight bold
        color #fff
        cursor pointer
        text-align center
        border-radius 50%
        &:hover, &:focus
          background bgDarkColor
</style>



// WEBPACK FOOTER //
// Toolbar.vue?62219216